import { AppShell, Avatar, Box, Burger, Group, Tooltip } from "@mantine/core"
import Link from "next/link"
import type { FC } from "react"
import { useAuth } from "@/hooks"
import { buildUserURL } from "@/utils"
import { Logo } from ".."
import { ClientOnly } from "../utils/ClientOnly"

type TProps = {
  title?: FC<any>
  toggleNavbar: () => void
  navbarOpened: boolean
}

export function AppHeader({ toggleNavbar, navbarOpened }: TProps) {
  const { user } = useAuth()

  if (!user) return null

  return (
    <AppShell.Header px="md">
      <Group gap="md" h="100%" justify="space-between">
        <Group gap="xs">
          <Burger mr="xl" size="sm" hiddenFrom="sm" opened={navbarOpened} onClick={toggleNavbar} />
          <Logo />
        </Group>
        <Box>
          <ClientOnly>
            <Link href={buildUserURL(user.id)}>
              <Tooltip label="Open profile" position="bottom">
                <Avatar radius={50} src={user?.picture} size={30} />
              </Tooltip>
            </Link>
          </ClientOnly>
        </Box>
      </Group>
    </AppShell.Header>
  )
}
